import { useState } from 'react';
import type { GuideCommand } from '../../shared/guide';

/**
 * 教材スライドの .cmd-hero と同じ見た目でコマンドを見せる。
 * キーボードの刻印は大文字なので、子どもが不安にならないよう小文字と大文字を2段併記する。
 * タブレットから離れたPCで入力する子のために、全画面に大きく出すボタンも付ける。
 */
export function CommandHero({ command }: { command: GuideCommand }) {
  const [zoomed, setZoomed] = useState(false);
  const upper = command.input.toUpperCase();

  return (
    <div className="cmd-hero">
      <div className="cmd-hero-head">
        <p className="cmd-hero-label">▶ うつ コマンド</p>
        <button type="button" className="cmd-zoom" onClick={() => setZoomed(true)}>
          🔍 おおきく
        </button>
      </div>
      <p className="cmd-lower">{command.input}</p>
      <p className="cmd-upper">{upper}</p>
      <p className="cmd-note">{command.note ?? '※ 大文字・小文字 どちらでも OK！'}</p>

      {zoomed && (
        <button type="button" className="cmd-overlay" onClick={() => setZoomed(false)}>
          <span className="cmd-hero-label">▶ うつ コマンド</span>
          <span className="cmd-overlay-lower">{command.input}</span>
          <span className="cmd-overlay-upper">{upper}</span>
          <span className="cmd-overlay-close">タップで とじる</span>
        </button>
      )}
    </div>
  );
}
